<ng-container *ngFor="let action of editableTableActions">
    <ntap-dynamic [class.hidden]="!isActionVisible(action)" [compId]="$any(action).ui_component" [inputParam]="action"></ntap-dynamic>
</ng-container>